import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { LuxonDatePipe } from '@libs/shared/ui';
import { ProductBundleType } from '@libs/shop/models';
import { DateTime } from 'luxon';

@Component({
  selector: 'ui-product-bundle-valid-to-label',
  imports: [
    LuxonDatePipe,
  ],
  templateUrl: './product-bundle-valid-to-label.component.html',
  styleUrl: './product-bundle-valid-to-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductBundleValidToLabelComponent {
  public bundleType: InputSignal<ProductBundleType> = input('closed' as ProductBundleType);
  public showDot: InputSignal<boolean> = input(false);
  public validTo: InputSignal<string | undefined> = input();
  public validFrom: InputSignal<string | undefined> = input();
  public showActionLabel: InputSignal<boolean> = input(true);

  public validToDate: Signal<DateTime | undefined> = computed(() => {
    const validTo: string | undefined = this.validTo();

    if (!validTo) {
      return undefined;
    }

    const date: DateTime = DateTime.fromISO(validTo);

    return date.isValid ? date : undefined;
  });

  // Calendar days remaining; validTo includes the entire local day.
  public remainingDays: Signal<number | undefined> = computed(() => {
    const validToDate: DateTime | undefined = this.validToDate();

    if (!validToDate) {
      return undefined;
    }

    const diffInDays: number = validToDate.startOf('day').diff(DateTime.now().startOf('day'), 'days').days;

    return diffInDays < 0 ? undefined : Math.floor(diffInDays);
  });

  // The validity date is today.
  public showEndsToday: Signal<boolean> = computed(() => this.remainingDays() === 0);

  // 1–7 days left ("Noch 1 Tag" / "Noch X Tage")
  public showDaysLeft: Signal<boolean> = computed(() => {
    const remainingDays: number | undefined = this.remainingDays();

    return remainingDays !== undefined && remainingDays >= 1 && remainingDays <= 7;
  });
}
